<!--  -->
<template>
  <div class="container">
    <!-- 遮罩层 -->
    <van-overlay :show="$store.state.isLoading">
      <div class="wrapper" @click.stop>
        <!-- <h2>Loading...</h2> -->
        <i class="el-icon-loading" style="font-size: 48px; color: #fff"></i>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        showOverlay: this.$store.isLoading,
      };
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
      // console.log(this.$store.state.isLoading);
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {},
    methods: {},
  };
</script>
<style scoped lang="less">
  /* @import url(); 引入css类 */
  .container {
    ::v-deep .van-overlay {
      z-index: 2046 !important;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  h2 {
    font-size: 1.5rem;
    color: #fff;
  }
</style>
